// Hash determinístico — mesmo id (ou sigla, quando o id ainda não existe numa
// linha otimista) sempre mapeia para o mesmo token, sem índice de array nem
// aleatoriedade (certame-catalog/spec.md, "Avatar com iniciais e tom estável").
const AVATAR_ACCENT_TOKENS = ["blue", "purple", "green", "cyan"] as const;
type AvatarAccentToken = (typeof AVATAR_ACCENT_TOKENS)[number];

const AVATAR_ACCENT_CLASSES: Record<AvatarAccentToken, string> = {
  blue: "bg-accent-blue/[0.12] text-accent-blue-ink",
  purple: "bg-accent-purple/[0.12] text-accent-purple-ink",
  green: "bg-accent-green/[0.12] text-accent-green-ink",
  cyan: "bg-accent-cyan/[0.12] text-accent-cyan-ink",
};

function certameAvatarAccent(id?: string, fallback?: string): AvatarAccentToken {
  const key = id || fallback || "";
  let sum = 0;
  for (let i = 0; i < key.length; i++) {
    sum += key.charCodeAt(i);
  }
  return AVATAR_ACCENT_TOKENS[sum % AVATAR_ACCENT_TOKENS.length];
}

function initialsOf(abbreviation?: string): string {
  return (abbreviation ?? "").trim().slice(0, 2).toUpperCase();
}

export function CertameAvatar({
  id,
  abbreviation,
}: {
  id?: string;
  abbreviation?: string;
}) {
  const accent = certameAvatarAccent(id, abbreviation);
  return (
    <span
      aria-hidden
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[12px] font-semibold ${AVATAR_ACCENT_CLASSES[accent]}`}
    >
      {initialsOf(abbreviation)}
    </span>
  );
}
